var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "drilldown" },
    [
      _c(
        "pui-card",
        { staticStyle: { "flex-wrap": "nowrap" }, attrs: { title: "" } },
        [
          _vm.isLoading
            ? _c("pui-loader-spinner", {
                attrs: { title: `${_vm.$t("eventSubmittingModal.text")}...` },
              })
            : _vm._e(),
          !_vm.isLoading
            ? _c(
                "div",
                [
                  _c("unit-information"),
                  _c("unit-generation"),
                  _c("unit-reliability"),
                  _c("op-data-entry-details-tabs"),
                  _c("op-data-comand-buttons"),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }